import axios from './axios';

export function createOrder(order) {
    return axios.post('/api/orders/order', order).then(res => res.data);
}

export function getOrderById(id) {
    return axios.get(`/api/orders/order/${id}`).then(res => res.data);
}

export function getOrderByOrderNumber(orderNumber) {
    return axios.get(`/api/orders/order/number/${orderNumber}`).then(res => res.data);
}

export function getAllOrders() {
    return axios.get('/api/orders/order').then(res => res.data);
}

export function updateOrder(id, order) {
    return axios.put(`/api/orders/order/${id}`, order).then(res => res.data);
}

export function deleteOrder(id) {
    return axios.delete(`/api/orders/order/${id}`).then(res => res.status === 204);
}

export function queryOrders(params) {
    return axios.post('/api/orders/query', params).then(res => res.data);
}

export function getPendingPaymentOrder(orderNumber) {
    return axios.get(`/api/orders/pending-payment/${orderNumber}`).then(res => res.data);
}

export function createInvoiceManually(orderNumber) {
    return axios.post(`/api/orders/order/${orderNumber}/invoice`).then(res => res.data);
}